import { createRoot } from 'react-dom/client';
import { StyledEngineProvider } from '@mui/material/styles';
import 'dayjs/locale/pt-br';
import dayjs from 'dayjs';

// solution for @mui/x-date-pickers locale
dayjs.locale('pt-br');
import App from '@/App';
import { hideBootLoader } from '@/utils/bootLoader';

createRoot(document.getElementById('root')!).render(
  <StyledEngineProvider injectFirst>
    <App />
  </StyledEngineProvider>,
);

hideBootLoader();
